/** @jsxImportSource @emotion/react */
import React, { FC, PropsWithChildren } from 'react';
import cn from 'classnames';
import { Grid } from '@/components';
import { styled, css } from '@mui/material';
import { customColors } from '@/theme';
const SlideTextContent = styled('div')`
  h2 {
    font-weight: 700;
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 25px;
    margin-top: 0;
    letter-spacing: 0.3px;
  }
  p {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    white-space: pre;
    letter-spacing: 0.1px;
  }
`;
export const Slide: FC<
  PropsWithChildren<{ image: string; className?: string }>
> = ({ image, children, className }) => {
  return (
    <Grid
      container
      className={cn(className, 'slide')}
      sx={{
        height: '100%',
        backgroundColor: customColors.sliderBgColor,
        color: 'white',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundImage: `url(${image})`,
      }}
    >
      <Grid
        xsOffset={1.5}
        xs={9}
        sx={{ padding: '40px 0', justifyContent: 'stretch', display: 'flex' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div></div>
          <div>
            <div
              css={css`
                margin-bottom: 80px;
                min-height: 228px;
              `}
            >
              <SlideTextContent>{children}</SlideTextContent>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
